export const FETCH_PLANS_QUERY = "fetchPlans";
export const FETCH_PRORATION_QUERY = "fetchSettings";
export const FETCH_EMPIRE_PRORATION = "fetchEmpireProrationPrice";
export const FETCH_PERSONALIZATION_QUERY = "fetchPersonalization";
export const FETCH_USER_STORES_QUERY = "fetchUserStores";
